// extracted by mini-css-extract-plugin
module.exports = {"info":"InfoBlock_info__3JlHn","title":"InfoBlock_title__2B3nf","flex":"InfoBlock_flex__3MdJB"};